import { showModal } from '../helpers/modal.js';

const cartItemsContainer = document.querySelector('.cart-items-container');
const subTotalElement = document.querySelector('.subtotal');
const checkOutButton = document.getElementById('toCheckout');

function renderCartItems(cart) {
    cartItemsContainer.innerHTML = ''; 

    cart.forEach(item => {
        const cartItemHTML = `
            <div class="cart-items ${item.type}">
                <a href="/store/product/${item.photo_slug}"><img class="item-img" src="${window.baseURL}/assets/imgs/webp/${item.img}" alt="${item.photo_name}"></a>
                <ul class="item-description">
                    <li class="item-name">${item.name}</li>
                    <li class="type">${item.uiType}</li>
                    <li class="size">${item.size}</li>
                    <div class="remove">Remove Item</div>
                </ul>
                <div class="qty">
                    <button class="decrease-qty" data-unit-price="${item.unitPrice}">-</button>
                    <span class="qty-number">${item.quantity}</span>
                    <button class="increase-qty" data-unit-price="${item.unitPrice}">+</button>
                </div>
                <div class="price">$${item.price}</div>
 <!--               <div class="remove">remove</div> -->
            </div>
        `;

        cartItemsContainer.innerHTML += cartItemHTML;
        addQuantityEventListeners(); 
    });
}

// Function to retrieve cart from local storage
function getCart() {
    return JSON.parse(localStorage.getItem('cart')) || [];
}

// Function to update the subtotal
function updateSubtotal(cart) {
    let subTotal = 0;

    cart.forEach(item => {
        subTotal += parseFloat(item.price);
    });

    subTotalElement.innerText = `$${subTotal.toFixed(2)}`;
}

// Function to update the item count in the cart summary
function updateItemCountInCartSummary() {
    const itemCountElement = document.querySelector('.item-count');
    const storedCart = getCart();
    const totalItems = storedCart.reduce((acc, item) => acc + (item.quantity || 0), 0);
    itemCountElement.innerText = totalItems;
}

// function to remove an item from the cart
function removeItemFromCart(index) {
    const cart = getCart();
    cart.splice(index, 1); 
    localStorage.setItem('cart', JSON.stringify(cart));
    renderCartItems(cart);
    if (cart.length === 0) {
        cartItemsContainer.innerHTML = showEmptyCartMessage();
        subTotalElement.innerText = '$0.00';
    }
    updateSubtotal(cart);
    updateItemCountInCartSummary();
    updateCartItemCount();
    addRemoveEventListeners();
}

// Add remove event listeners to remove buttons
function addRemoveEventListeners() {
    const removeButtons = document.querySelectorAll('.remove');
    removeButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
            removeItemFromCart(index);
        });
    });
}

function showEmptyCartMessage() {
    return `
        <div class="empty-cart-message">
            <h3>Your cart is empty.</h3>
            <p>Would you like to add something?</p>
            <a href="/store" class="btn">Shop Now</a>
        </div>
    `;
}

// render cart upon page load
const cart = JSON.parse(localStorage.getItem('cart')) || [];

// check if cart is empty
if (cart.length === 0) {
    cartItemsContainer.innerHTML = showEmptyCartMessage();
    subTotalElement.innerText = '$0.00';
} else {
    renderCartItems(cart);
    updateSubtotal(cart);
    updateItemCountInCartSummary();
    addRemoveEventListeners();
}

function addQuantityEventListeners() {
    const decreaseQtyButtons = document.querySelectorAll('.decrease-qty');
    const increaseQtyButtons = document.querySelectorAll('.increase-qty');
    
    decreaseQtyButtons.forEach((button, index) => {
        const qtyElement = button.nextElementSibling;
        const itemType = button.closest('.cart-items').classList[1];
        const priceElement = button.closest('.cart-items').querySelector('.price');
        const unitPrice = button.dataset.unitPrice;
    
        button.addEventListener('click', () => {
            let currentQty = parseInt(qtyElement.innerText, 10);
            let newPrice;
    
            if(itemType === `notecard`) {
                if (currentQty > 6) {
                    currentQty --;
                    qtyElement.innerText = currentQty;
    
                    // Update the price
                    const newPrice = (currentQty * parseFloat(unitPrice)).toFixed(2);
                    priceElement.innerText = `$${newPrice}`;
    
                    // Update the cart data
                    const cart = JSON.parse(localStorage.getItem('cart')) || [];
                    cart[index].quantity = currentQty;
                    cart[index].price = newPrice;
                    localStorage.setItem('cart', JSON.stringify(cart));
    
                    // Update subtotal
                    updateSubtotal(cart);
                    updateItemCountInCartSummary();
                    updateCartItemCount();
    
                } else {
                    showModal('<p>Minimum quantity is 6</p>');
                }
            } else {
                if (currentQty > 1) {
                    currentQty --;
                    qtyElement.innerText = currentQty;
    
                    // Update the price
                    const newPrice = (currentQty * parseFloat(unitPrice)).toFixed(2);
                    priceElement.innerText = `$${newPrice}`;
    
                    // Update the cart data
                    const cart = JSON.parse(localStorage.getItem('cart')) || [];
                    cart[index].quantity = currentQty;
                    cart[index].price = newPrice;
                    localStorage.setItem('cart', JSON.stringify(cart));
    
                    // Update subtotal
                    updateSubtotal(cart);
                    updateItemCountInCartSummary();
                    updateCartItemCount();
                }
            }
        });
    });
    increaseQtyButtons.forEach((button, index) => {
        const qtyElement = button.previousElementSibling;
        const priceElement = button.closest('.cart-items').querySelector('.price');
        const unitPrice = parseFloat(button.dataset.unitPrice);
    
        button.addEventListener('click', () => {
            let currentQty = parseInt(qtyElement.innerText, 10);
    
            currentQty ++;
            qtyElement.innerText = currentQty;
    
            const newPrice = (currentQty * parseFloat(unitPrice)).toFixed(2);
            priceElement.innerText = `$${newPrice}`;
    
            const cart = JSON.parse(localStorage.getItem('cart')) || [];
            cart[index].quantity = currentQty;
            cart[index].price = newPrice;
            localStorage.setItem('cart', JSON.stringify(cart));
            updateCartItemCount();
            updateSubtotal(cart);
            updateItemCountInCartSummary();
        });
    });
}

// Add event listener to the checkout button
checkOutButton.addEventListener('click', (e) => {
    e.preventDefault();

    const cart = getCart();
    
    if (cart.length === 0) {
        showModal('<h3>Your cart is empty.</h3>');
        return;
    } else {
        window.location.href = '/store/checkout';
    }
});